<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid" v-loading.fullscreen.lock="isLoading">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
  import _nav from '../_nav'
  import {Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb} from '../components'
  import {mapState} from 'vuex'

  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppAside,
      AppFooter,
      Breadcrumb
    },
    data() {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState([ 'userCurrent']),
      nav() {
        return _nav.items
      },
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue